import React from 'react';

// ANTD
import { Tabs, Badge, Checkbox } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
// Components
import { FormattedMessage } from 'react-intl';
import { isIE } from 'react-device-detect';
import FriendsSelect from '../components/friendsSelect';
import DownloadTab from './downloadTab';
import HistoryTab from './historyTab';
import FriendsTab from './friendsTab';
import MyTourTab from './myTourTab';

// CSS
import './downloadGpsTabs.css';
import { TRASFER_GPS_TABS } from '../../../../constants/transfer.constants';
// CONST
const { TabPane } = Tabs;

export const dataList = (data, props) => {
  const arrData = [];

  data.forEach((item) => {
    arrData.push(
      <div key={item.id} className="listItem">
        <Checkbox defaultChecked />
        <div>{item.title}</div>
        <DeleteOutlined
          className="dltIcon"
          style={{ position: 'absolute', right: 0 }}
          onClick={() => props.TourBasketDataDelete(item)}
        />
      </div>
    );
  });

  return arrData;
};

const DownloadGpsTabs = (props) => {
  const tabStyle = () => {
    return isIE
      ? { height: '100%', minHeight: '180px' }
      : {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '180px',
        };
  };

  const GetDonwloadTab = () => (
    <Badge count={props.downloadTourGps.data.length}>
      <FormattedMessage id="Download" defaultMessage="Download" />
    </Badge>
  );

  return (
    <Tabs
      activeKey={props.activeTab}
      animated={false}
      onTabClick={(key) => props.handleChangeActiveTab(key)}
      style={tabStyle()}
    >
      <TabPane tab={<GetDonwloadTab />} key={TRASFER_GPS_TABS.DOWNLOAD}>
        <DownloadTab {...props} />
      </TabPane>

      <TabPane
        tab={<FormattedMessage id="History" defaultMessage="History" />}
        key={TRASFER_GPS_TABS.HISTORY}
      >
        <HistoryTab {...props} />
      </TabPane>

      <TabPane
        tab={<FormattedMessage id="My tours" defaultMessage="My tours" />}
        key={TRASFER_GPS_TABS.MY_TOURS}
      >
        <MyTourTab {...props} />
      </TabPane>

      <TabPane
        tab={<FriendsSelect {...props} className="downloadFriendSelect" />}
        key={TRASFER_GPS_TABS.FRIEND_TOURS}
      >
        <FriendsTab {...props} />
      </TabPane>
    </Tabs>
  );
};

export default DownloadGpsTabs;
